var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.calendarRules || _vm.calendarRules.length === 0)?_c('div',{staticClass:"px-1 small text-secondary"},[_vm._v(" - ")]):_c('div',{staticClass:"px-1 small"},[_vm._v(" "+_vm._s(_vm.formattedRules)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }